import { createEntityCollections } from '@angular-ru/cdk/entity';
import { StateRepository } from '@angular-ru/ngxs/decorators';
import { NgxsDataEntityCollectionsRepository } from '@angular-ru/ngxs/repositories';
import { Injectable } from '@angular/core';
import { State } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IContextData, IDataContextBucket } from './data-context-repository.models';

@StateRepository()
@State({
    name: 'dataContextState',
    defaults: createEntityCollections()
})
@Injectable()
export class DataContextBucketRepositoryService extends NgxsDataEntityCollectionsRepository<IContextData> implements IDataContextBucket {

    constructor() {
        super();
    }
    getContextData<T extends IContextData>(id: string): T {
        if (this.ids.indexOf(id) === -1) {
            this.addContextData(id);
        }
        return this.selectOne(id) as T;
    }

    getContextData$<T extends IContextData>(id: string): Observable<T> {
        this.getContextData<T>(id);
        return this.entitiesArray$.pipe(map(array => array.find(item => item.id === id) as T));
    }

    addContextData<T extends IContextData>(id: string) {
        const contextData = {} as T;
        (contextData as IContextData).id = id;
        this.addOne(contextData)
    }

    saveContextData<T extends IContextData>(id: string, data: T) {
        const contextData = {} as T;
        (contextData as IContextData).id = id;
        this.updateOne({ id, changes: data });
    }

    removeContextData(id: string) {
        this.removeOne(id);
    }
}
